<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4 header-row">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Tabela DIFAL</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/notas-fiscais/natureza-operacao"
                                aria-label="Voltar para Natureza de Operação">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Matriz de alíquotas por UF e fórmulas do DIFAL.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <mat-tab-group class="main-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true"
            (selectedTabChange)="$event.index === 1 ? onTabFormulasAtivada() : null">

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">table_rows</mat-icon>
                    <span class="tab-label-text">DIFALs</span>
                </ng-template>
                <app-difais-lista></app-difais-lista>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">function</mat-icon>
                    <span class="tab-label-text">Fórmulas Padrão</span>
                </ng-template>
                <app-formulas-difal-tab
                    [grupos]="_gruposFormulas"
                    [isLoading]="_isLoadingFormulas"
                    (modeloEmpresaSelecionado)="alterarModeloEmpresa($event)">
                </app-formulas-difal-tab>
            </mat-tab>

        </mat-tab-group>

    </div>
</div>
